// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5ceb5ec9","455":"21f2b081","977":"96c9bc7b"}[chunkId] + ".chunk.js";
};